import script from "./SettingsHomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsHomePage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsHomePage.vue?vue&type=style&index=0&id=3beb36ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3beb36ce"]])

export default __exports__